import "@fontsource/rubik";
import "@fontsource/karla";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Buffer } from "buffer";
import * as Sentry from "@sentry/react";
import { configs } from "data/config";
import { ReactTagManager } from "react-gtm-ts";
import { PostHogProvider } from "posthog-js/react";

if (configs.NODE_ENV === "production" && configs.GOOGLE_TAG_ID) {
  ReactTagManager.init({
    debug: false,
    performance: false,
    code: configs.GOOGLE_TAG_ID || ""
  });
}

if (configs.NODE_ENV === "production" && configs.SENTRY_DSN) {
  Sentry.init({
    dsn: configs.SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

(window as any).Buffer = Buffer;

const options = {
  api_host: configs.POSTHOG_HOST
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <PostHogProvider apiKey={configs.POSTHOG_KEY} options={options}>
    <App />
  </PostHogProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// serviceWorker.register();

reportWebVitals();
